import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface Props {
  onClick: () => void
  disabled: boolean
}

const CompensateButton = ({ onClick, disabled }: Props) => {
  const label = disabled
    ? i18n.t('time_tracking.table.compensate.select')
    : i18n.t('time_tracking.table.compensate.selected')

  return (
    <Button disabled={disabled} onClick={onClick} type="primary">
      {label}
    </Button>
  )
}

export default CompensateButton
